import { getSettingsCommunicationChannelsApi as generatedGetSettingsCommunicationChannelsApi } from '../generated/settingsCommunicationChannels/getSettingsCommunicationChannels';

const getSettingsCommunicationChannelsApi = generatedGetSettingsCommunicationChannelsApi.enhanceEndpoints({
  endpoints: {
    getSettingsCommunicationChannels: {
      providesTags: ['SettingsCommunicationChannels'],
    },
  },
});

export const { useGetSettingsCommunicationChannelsQuery } = getSettingsCommunicationChannelsApi;
